<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        <strong>direkcijaparacin@gmail.com</strong><br />
        <span class="has-text-black">+381 35 564 369, +381 63 10 76 99 0</span>
      </p>
      <p>
        <strong>Јавно предузеће Дирекција за изградњу општине Параћин</strong
        ><br />
        <span class="has-text-grey"
          >Владике Николаја Велимировића 1, 35250 Параћин</span
        ><br />
        <span class="has-text-grey"
          >Радно време контакт центра: 07:30-14:30</span
        ><br />
        <span class="has-text-grey"
          >МБ 17018795, ПИБ 101094056, тек. рачун 160-0000000462420-13</span
        >
      </p>
      <img
        src="@/assets/images/all-secure-ucb-1.svg"
        alt="all-secure-ucb-1"
        class="headerImageCss"
        usemap="#unicredit"
      />
      <map name="unicredit">
        <area
          shape="rect"
          coords="0,0,120,48"
          alt="Unicredit banka"
          href="https://www.unicreditbank.rs/rs/"
          target="_blank"
        />
      </map>
      <!-- <br /> -->
      <img
        src="@/assets/images/all-secure-3ds.svg"
        alt="all-secure-3ds"
        class="headerImageCss"
        usemap="#allsecure"
      />
      <map name="allsecure">
        <area
          shape="rect"
          coords="125,0,250,48"
          alt="Allsecure"
          href="https://www.allsecure.rs/"
          target="_blank"
        />
      </map>
      <br />
      <router-link to="/uslovi-kupovine">Услови куповине</router-link>
      <!-- <b-image
        :src="require('@/assets/images/all-secure-3ds.svg')"
        alt="all-secure-3ds"
      ></b-image>
      <b-image
        :src="require('@/assets/images/all-secure-ucb-1.svg')"
        alt="all-secure-ucb-1"
      ></b-image> -->
    </div>
  </footer>
</template>

<script>
export default {}
</script>

<style>
.headerImageCss {
  height: 40px;
}
</style>
